import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import "./bdmcontrols.css";

function QueriesTable() {
  const [queries, setQueries] = useState([]);
  const [message, setMessage] = useState(null);
  const [config, setConfig] = useState(null);

  // Load config
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json:", err));
  }, []);

  // Fetch queries from backend
  const fetchQueries = () => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.GET_QUERIES}`, {
      method: "POST",
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && data.queries) {
          setQueries(data.queries);
        }
      })
      .catch(err => console.error("Failed to fetch queries:", err));
  };

  useEffect(() => {
    fetchQueries();
  }, [config]);

  // Handle Accept/Reject action
  const handleAction = (id, action) => {
    if (!config) return;

    const status = action === "accept" ? 1 : 2; 

    fetch(`${config.BASE_URL}${config.UPDATE_QUERY}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: `id=${id}&status=${status}`,
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage({ type: "success", text: `Query ${action}ed successfully!` });
          // Remove the query from state
          setQueries(prev => prev.filter(q => q.id !== id));
        } else {
          setMessage({ type: "error", text: data.message || "Failed to update query" });
        }
      })
      .catch(() => setMessage({ type: "error", text: "Network error" }));
  };

  // Auto-hide message
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <div className="queries-container">
      <h2 className="queries-title">User Queries</h2>

      {/* Message */}
      {message && (
        <div className={`queries-message ${message.type}`}>
          <span>{message.text}</span>
          <X size={18} onClick={() => setMessage(null)} style={{ cursor: "pointer" }} />
        </div>
      )}

      <table className="queries-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name</th>
            <th>Mail</th>
            <th>Query</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {queries.length > 0 ? (
            queries.map((q, index) => (
              <tr key={q.id}>
                <td>{index + 1}</td>
                <td>{q.name}</td> 
                <td>{q.mail}</td>
                <td>{q.query}</td>
                <td>
                  <button className="queries-btn accept" onClick={() => handleAction(q.id, "accept")}>
                    Accept
                  </button>
                  <button className="queries-btn reject" onClick={() => handleAction(q.id, "reject")}>
                    Reject
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="queries-empty">No pending queries</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default QueriesTable;
